// src/components/UI/Dashboard/DataTable.jsx
import React from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';

// Helper to get nested properties with fallback support
const getComplexValue = (obj, expression) => {
    // Handle simple fields
    if (!expression.includes('??')) {
        return expression.split('.').reduce((acc, part) => {
            if (acc == null) return null;
            return acc[part];
        }, obj);
    }

    // Handle fallback expressions
    const paths = expression.split('??').map(path => path.trim());
    for (const path of paths) {
        const value = path.split('.').reduce((acc, part) => {
            if (acc == null) return null;
            return acc[part];
        }, obj);

        if (value !== null && value !== undefined) {
            return value;
        }
    }

    return null;
};

const DataTable = ({ title, columns, data, dateField }) => {
    return (
        <div className="bg-white rounded-lg shadow p-4 w-full">
            <h3 className="text-lg font-semibold mb-4">{title}</h3>
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow className="bg-gray-100">
                            {columns.map((column) => (
                                <TableCell key={column.field}>{column.headerName}</TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data.map((row) => (
                            <TableRow key={row.id || row.request_id}>
                                {columns.map((column) => {
                                    const value = getComplexValue(row, column.field);

                                    // Format date fields
                                    if (column.field === dateField || column.isDate) {
                                        return (
                                            <TableCell key={`${row.id}-${column.field}`}>
                                                {value ? new Date(value).toLocaleDateString() : '-'}
                                            </TableCell>
                                        );
                                    }

                                    // Format price fields
                                    if (column.isPrice) {
                                        return (
                                            <TableCell key={`${row.id}-${column.field}`}>
                                                {value ? `$${parseFloat(value).toFixed(2)}` : '-'}
                                            </TableCell>
                                        );
                                    }

                                    return (
                                        <TableCell key={`${row.id}-${column.field}`}>
                                            {value || '-'}
                                        </TableCell>
                                    );
                                })}
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    );
};

export default React.memo(DataTable);